import Vue from "vue";
import VueRouter from "vue-router";
import { userService, rolesService } from "@/_services";
// router setup
import routes from "./routes";

// plugin setup
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
});

// Tras un despliegue, una pestaña abierta (o cacheada) puede pedir trozos de la versión anterior que ya no existen:
// se recarga la página una vez para cargar la versión nueva (como mucho una vez cada 10 s, para no entrar en bucle)
router.onError((error) => {
  if (!/Loading (CSS )?chunk .* failed/i.test((error && error.message) || "")) return;
  try {
    const ultimaRecarga = Number(sessionStorage.getItem("recargaPorVersion") || 0);
    if (Date.now() - ultimaRecarga < 10000) return;
    sessionStorage.setItem("recargaPorVersion", String(Date.now()));
  } catch (e) {
    return; // Sin sessionStorage (algún modo privado) no se recarga: se queda como antes
  }
  window.location.reload();
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/recover_password", "/restore_login"];
  const authRequired = !publicPages.includes(to.path);
  const user = JSON.parse(localStorage.getItem("user"));
  const pagesRoles = JSON.parse(localStorage.getItem("roles-menu"));
  const forbiddenPages = rolesService.getForbiddenPages(pagesRoles, user);
  if (authRequired) {
    if (!user) return next("/login");
    else {
      const user_entity = user;
      if (!userService.esFranquiciadora(user_entity)) return next("/login");
      if (forbiddenPages.includes(to.path))
        return next("/franquiciadora/forbidden");
    }
  }

  next();
});

export { router };
